import { useStaticQuery, graphql } from "gatsby"

export const useHomeCouponsQuery = () => {
    const { wpPage } = useStaticQuery(
        graphql`
        query HomeCouponsQuery {
            wpPage(title: {eq: "Home"}) {
              coupons {
                couponsBackgroundImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                couponsBackgroundImageAltText
                couponsHeading
                couponsCoupons {
                  couponsContent
                  couponsAmountOff
                  couponsPercentageOrFixedAmount
                  couponsCouponCodeText
                  couponsCouponCode
                }
              }
            }
          }
        `)
return wpPage.coupons
}